import { createAlgoliaInsightsPlugin } from '@algolia/autocomplete-plugin-algolia-insights'
import insightsClient from '../clients/insights'

export default createAlgoliaInsightsPlugin({
  insightsClient,
})
